import { createContext } from 'react';

const ChapterAccordionContext = createContext({});

export default ChapterAccordionContext;
